import clsx from "clsx";
import { forwardRef } from "react";

import styles from "./styles.module.scss";
import IconButton from "../button/iconButton.tsx";
import InputLabel from "../input-label";

const iconClear = "../icons/input-clear.svg";

export type TextAreaProps = {
  className?: string;
  value?: string;
  maxChars?: number;
  onChange?: (value: string) => void;
  onChangeClearButton?: () => void;
  icon?: string;
  clearButton?: boolean;
  error?: string;
  tall?: boolean;
  label?: React.ReactNode;
} & Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  "value" | "onChange"
>;

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (props, ref) => {
    const {
      value,
      onChange,
      onChangeClearButton,
      icon,
      clearButton,
      className,
      error,
      maxChars,
      readOnly,
      tall,
      label,
      ...rest
    } = props;

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (onChange) {
        let val = event.target.value.trimStart();
        if (maxChars && maxChars > 0) {
          val = val.slice(0, maxChars);
        }
        onChange(val);
      }
    };

    return (
      <div
        className={className}
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        <div className={styles.container}>
          {label && <InputLabel>{label}</InputLabel>}

          <textarea
            value={value}
            readOnly={readOnly}
            onChange={handleChange}
            className={clsx(
              styles.textarea,
              tall && styles.tallInput,
              icon && styles.inputWithIcon,
              error && styles.inputWithError
            )}
            {...rest}
          />

          {icon && (
            <img
              className={styles.icon}
              alt=""
              src={icon}
              width={styles.inputIconSize}
              height={styles.inputIconSize}
            />
          )}

          {clearButton && (
            <IconButton
              className={styles.clearButton}
              icon={iconClear}
              alt="Очистить"
              iconWidth={styles.inputClearButtonSize}
              iconHeight={styles.inputClearButtonSize}
              onClick={() => {
                onChangeClearButton && onChangeClearButton();
                onChange?.("");
              }}
            />
          )}
        </div>

        {error && <p className={styles.error}>{error}</p>}
      </div>
    );
  }
);

TextArea.displayName = "TextArea";

export default TextArea;
